(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;
         vm.getLanguage = getLanguage;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            document.documentElement.setAttribute("lang", languageKey);
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }

        function getLanguage(){
           return tmhDynamicLocale.get();
        }
    }
})();
